import $ from 'jquery';
import 'slick-carousel';

export class Carousel
{
  constructor(element, after, settings = {}) {
    this.el = element;
    this.settings = settings;
    $(this.el).slick(this.settings);
    this.afterEventEl = after;
    this.buttonEl = document.getElementById('products-button');
  }

  setupTabClicks(tabSelector, tabItemSelector) {
    const tabs = document.querySelectorAll(tabSelector);
    for (const tabEl of tabs) {
      tabEl.addEventListener('click', () => {this.slide(tabEl)});
    }

    $(this.el).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      if (event.target == this.afterEventEl) {
        const currentSelectedTab = document.querySelectorAll(tabItemSelector + '.isSelected');
        const targetSelectedTab = document.querySelectorAll('[data-slideto="' + nextSlide.toString() + '"]');

        this.toggleSelectedClass(currentSelectedTab[0], targetSelectedTab[0].parentNode);
      }
    });
  }

  slide(targetEl) {
    const targetSlideNum = targetEl.dataset.slideto;
    const slickObj = $(this.el)[0].slick;
    slickObj.slickGoTo(targetSlideNum);
  }

  toggleSelectedClass(currSelected, targetSelected) {
    currSelected.classList.toggle('isSelected');
    targetSelected.classList.toggle('isSelected');
  }

  reSlick(newSettings) {
    $(this.el).slick(newSettings);
  }

  getSlick() {
    return $(this.el)[0].slick;
  }
}
